import { reset } from 'src/store'

const loggedInStates = () => {
  return [
    'company_newbie',
    'company'
  ]
}

const defaultStates = () => {
  return {
    // Company
    company_newbie: [],
    company: {
      company_name: null,
      id: -1,
      industry_settings: {
        setup_reporting: false,
        setup_prefill_inventory: false
      },
      branding: {},
      ecard: {},
      acc_enabled: false,
      timezone: process.env.SYSTEM_TIMEZONE,
      hide_timezone_options: true,
      appointments_always_show_timezone: false,
      appointments_color_allocation: 'STAFF',
      appointments_default_color: '#FFFFFF',
      appointment_status_colors: {},
      appointment_invoiced_status_colors: {},
      appointment_paid_status_colors: {},
      calendar_start_of_week: 0,
      appointments_prefill_invoice_description: false,
      appointments_prefill_quotation_description: false,
      sales_account: null,
      inventory_account: null,
      payment_account: null,
      provider_payment_account: null,
      cash_payment_account: null,
      gst_tax: null,
      gst_free_tax: null,
      gst_not_registered_tax: null,
      gst_registered: false,
      default_gst: 'NONE',
      inventory_tax_type: 'NONE',
      inventory_prefill_column: 'NAME',
      invoices_default_payment_reminders: [],
      invoicing_due_date: null,
      rounding_method: 'HALF_EVEN',
      drawings_show_ruler: true,
      drawings_snap_to_grid: true,
      drawings_snap_units: 10,
      drawings_unit_of_measurement: 'px',
      drawings_pixels_per_unit: 1,
      drawings_auto_svg_scale: 0.5,
      reports_send_before_invoice_payment: true,
      appointments_send_client_unscheduled_reminders: true,
      appointments_auto_complete_on_forms: false,
      appointments_lock_complete_without_forms: true,
      appointments_required_forms_icon_color: '#ffffff',
      appointments_invoiced_icon_color: '#ffffff',
      appointments_paid_icon_color: '#ffffff',
      appointments_lock_complete_without_checklists: false,
      appointments_checklists_icon_color: '#ffffff',
      appointments_auto_complete_checklist_tasks: true,
      checklist_invoice_done_when: 'FINALISED',
      checklist_quotation_done_when: 'FINALISED',
      checklist_report_done_when: 'PUBLISHED',
      appointments_send_confirmation_email_default: false,
      clients_show_financial_summary: true
    }
  }
}

export default {
  namespaced: true,
  state: defaultStates(),
  mutations: {
    reset (state) {
      reset(state, loggedInStates(), defaultStates())
    },
    setCompany (state, value) {
      Object.assign(state.company, value)
    },
    setCompanyNewbie (state, { values = [], mode = 'add' }) {
      if (!Array.isArray(values)) {
        values = [values]
      }
      for (const ele of values) {
        if (mode === 'add' && !state.company_newbie.includes(ele)) {
          state.company_newbie.push(ele)
        }
        else if (mode === 'remove') {
          const eleIndex = state.company_newbie.indexOf(ele)
          if (eleIndex > -1) {
            state.company_newbie.splice(eleIndex, 1)
          }
        }
      }
    }
  },
  getters: {
    getCompany: state => state.company,
    getCompanyNewbie: state => state.company_newbie
  }
}
